// eslint-disable-next-line no-unused-vars
import React, { Fragment } from "react"
import LogoUploader from "./LogoUploader/index"
import ImageDesigner from "./ImageDesigner/ImageDesigner"
import Slider from "./ImageDesigner/Slider"
import bags from "./ImageDesigner/bags"
import { useHistory } from "react-router-dom"
import Step from "./components/Step"
import { Button, AppContainer, ButtonRow } from "./components/styled"

const IMG_ROOT_PATH = "/assets/go-bags/bags/"

const CustomizationApp = ({ headerTitle }) => {
  const history = useHistory()
  const [preview, setPreview] = React.useState(null)
  const [bagPreview, setBagPreview] = React.useState({
    original: null,
    thumb: null,
  })

  const [selected, setSelected] = React.useState(0)

  const current = bags[selected]

  const [selectedBagSrc, setSelectedSrc] = React.useState(current.src)
  const [selectedThumbnailSrc, setSelectedThumbnailSrc] = React.useState(
    current.options[0].thumbnail
  )

  const onChangePreview = (preview) => {
    setBagPreview(preview)
  }

  const onSelect = (selectedIndex, { src, thumbnail }) => {
    setSelected(selectedIndex)
    setSelectedSrc(src)
    setSelectedThumbnailSrc(thumbnail)
  }

  const onGoToRequest = () => {
    history.push({
      pathname: "/togo/request-quote",
      state: {
        preview,
        bagPreview,
        model: current.modelName,
      },
    })
  }

  React.useLayoutEffect(() => {
    if (document && headerTitle) {
      document.getElementById("pageTitle").innerText = headerTitle
    }
  }, [])

  return (
    <AppContainer>
      <img
        className="img-responsive"
        src="/assets/go-bags/gobags.gif"
        alt="gobag prview"
      />
      <div>
        <Step title="Select a gobag">
          <Slider
            imgRootPath={IMG_ROOT_PATH}
            bags={bags}
            onSelect={onSelect}
            selected={selected}
          />
        </Step>
        <Step
          style={{
            padding: 0,
            borderWidth: 1,
            borderStyle: "solid",
            borderColor: "#2EACE1",
            cursor: "pointer",
          }}
          title="Upload your design"
        >
          <LogoUploader preview={preview} onChange={setPreview} />
        </Step>

        <Step title="View and Download your GoBag">
          <ImageDesigner
            imgRootPath={IMG_ROOT_PATH}
            logoImg={preview}
            {...current}
            src={IMG_ROOT_PATH.concat(selectedBagSrc)}
            thumbnailSrc={IMG_ROOT_PATH.concat(selectedThumbnailSrc)}
            onChangePreview={onChangePreview}
          >
            {({ onDownload }) => (
              <ButtonRow>
                <Button
                  outline
                  onClick={preview === null ? undefined : onDownload}
                  disabled={preview === null}
                >
                  Download
                </Button>
                <Button
                  disabled={bagPreview.original === null}
                  onClick={onGoToRequest}
                >
                  Get a Quote
                </Button>
              </ButtonRow>
            )}
          </ImageDesigner>
        </Step>
      </div>
    </AppContainer>
  )
}

CustomizationApp.defaultProps = {
  headerTitle: "Customize Your GoBag",
}

export default CustomizationApp
